<template>
  <div class="modal fade" id="modal-cancel-reason" tabindex="-1" role="dialog" aria-labelledby="modal-cancel-reason" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <h3>Why did you cancel the request?</h3>
          <button
            v-for="option in cancel_options"
            :key="option.id"
            type="button"
            class="btn btn-block btn-dark"
            data-dismiss="modal"
            @click="handleCancelBookingReasonCallback(option.id)">
            {{ option.label }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['online'],

  methods: {
    handleCancelBookingReasonCallback (reason) {
      this.$emit('input', reason)
    }
  },

  computed: {
    cancelOptions () {
      return [
        { id: 'budget', label: 'Budget Issues' },
        { id: 'not_proceeding', label: 'Request Not Proceeding' },
        { id: 'talent_not_required', label: this.$options.filters.sentenceCase(this.$starLabel) + ' No Longer Required' },
        { id: 'other', label: 'Other' }
      ]
    }
  }
}
</script>
